import {api_opp_select_list} from '@/api/api'
import {getAction} from '@/api/tool'

export default  {
  data(){
    return {
      enumerate:{
        oppProjectType:[], //后端返回
        oppStage: [], //后端返回
        oppStatus:[], //后端返回
        oppApplicationType:[], //后端返回
        oppWinProbability:[], //后端返回
        oppProductType:[], //后端返回
        oppOneTime:[]
      },
    }
  },
  computed:{
    quoteType(){
      const L = this.$store.state.L || {}
      return [
        {value:'PQ', label: L.projectQuote},
        {value:'OQ', label: L.oneTime}
      ]
    }
  },
  methods:{
    getOppStatusColor(status){
      if(status==10){
        return 'brown'
      }
      if(status==20){
        return 'yellow'
      }
      if(status==30){
        return 'green'
      }
      if(status==40){
        return 'red'
      }
    },
    getQuoteType(val){
      if(val==='') return ''
      let text = ''
      this.quoteType.forEach((item)=>{
        if(item.value==val){
          text=item.label
        }
      })
      return text
    },
    getOppSelect(){
      getAction(api_opp_select_list).then(res=>{
        this.enumerate.oppProjectType=res.projectType
        this.enumerate.oppOneTime=res.oneTime
        this.enumerate.oppStage=res.stage
        this.enumerate.oppStatus=res.status
        this.enumerate.oppApplicationType=res.appType
        this.enumerate.oppWinProbability=res.winRate
        this.enumerate.oppProductType=res.productType
      })
    },
    getOppProjectTypeText(val){
      if(val==='') return ''
      let text = ''
      this.enumerate.oppProjectType.forEach((item)=>{
        if(item.code==val){
          text=item.nameEn
        }
      })
      return text
    },
    getOppApplicationTypeText(val){
      if(val==='') return ''
      let text = ''
      this.enumerate.oppApplicationType.forEach((item)=>{
        if(item.code==val){
          text=item.nameEn
        }
      })
      return text
    },
    getOppWinProbabilityText(val){
      if(val==='') return ''
      let text = ''
      this.enumerate.oppWinProbability.forEach((item)=>{
        if(item.code==val){
          text=item.nameEn
        }
      })
      return text
    },
    getOppStageText(val){
      if(val==='') return ''
      let text = ''
      this.enumerate.oppStage.forEach((item)=>{
        if(item.code==val){
          text=item.nameEn
        }
      })
      return text
    },
    getOppStatusText(val){
      if(val==='') return ''
      let text = ''
      this.enumerate.oppStatus.forEach((item)=>{
        if(item.code==val){
          text=item.nameEn
        }
      })
      return text
    },
  }
}